import img01 from "../../images/chapters/07/list/01.jpg";
import img02 from "../../images/chapters/07/list/02.jpg";
import img03 from "../../images/chapters/07/list/03.jpg";
import img04 from "../../images/chapters/07/list/04.jpg";
import img05 from "../../images/chapters/07/list/05.jpg";
import img06 from "../../images/chapters/07/list/06.jpg";
import img07 from "../../images/chapters/07/list/07.jpg";
import img08 from "../../images/chapters/07/list/08.jpg";
import img09 from "../../images/chapters/07/list/09.jpg";
import img10 from "../../images/chapters/07/list/10.jpg";
import img11 from "../../images/chapters/07/list/11.jpg";
import img12 from "../../images/chapters/07/list/12.jpg";
import img13 from "../../images/chapters/07/list/13.jpg";
import img14 from "../../images/chapters/07/list/14.jpg";
import img15 from "../../images/chapters/07/list/15.jpg";
import img16 from "../../images/chapters/07/list/16.jpg";
import img17 from "../../images/chapters/07/list/17.jpg";
import img18 from "../../images/chapters/07/list/18.jpg";
import img19 from "../../images/chapters/07/list/19.jpg";
import img20 from "../../images/chapters/07/list/20.jpg";

export const captions = [
  "Shadow of Lunar Module on lunar surface. Image taken from inside the LM\nafter landing at Tranquility Base.",
  "Buzz Aldrin inside the Lunar Module as it rests on the lunar module after completion of the Extravehicular Activities (EVA).",
  "Lunar Module thrusters with lunar surface in background. Seismometer is visible on the lunar surface. Image taken from inside the Lunar Module after landing at Tranquility Base.",
];

export const list = [
  img01,
  img02,
  img03,
  img04,
  img05,
  img06,
  img07,
  img08,
  img09,
  img10,
  img11,
  img12,
  img13,
  img14,
  img15,
  img16,
  img17,
  img18,
  img19,
  img20,
];
